import { Typography as MaterialUiText } from '@mui/material'

import { BaseTextProps } from './BaseText.types'

import './BaseText.scss'

const BaseText: React.FC<BaseTextProps> = ({ type, children, sx }): JSX.Element => {
	return (
		<MaterialUiText variant={type} className='base-text' sx={sx}>
			{children}
		</MaterialUiText>
	)
}

export default BaseText
